<template>
    <div class="dm-taxonomies-list" v-if="taxonomies">
        <div
            class="font-weight-bold dm-top-details-single mb-1 text-dark"
            v-if="taxonomies.category"
        >
            <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-0">
                <DownFlagSvg />
            </span>
            {{ taxonomies.category }}
        </div>
        <div
            class="font-weight-bold dm-top-details-single mb-1 text-muted"
            v-if="taxonomies.sub_category"
        >
            <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-0">
                <DownFlagSvg />
            </span>
            {{ taxonomies.sub_category }}
        </div>

        <div
            class="font-weight-bold dm-top-details-single mb-1 text-muted"
            v-if="taxonomies.sub_sub_category"
        >
            <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-0">
                <DownFlagSvg />
            </span>
            {{ taxonomies.sub_sub_category }}
        </div>

        <div
            class="font-weight-bold dm-top-details-single mb-1 text-muted"
            v-if="taxonomies.genre"
        >
            <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-0">
                <DownFlagSvg />
            </span>
            {{ taxonomies.genre }}
        </div>

        <div
            class="font-weight-bold dm-top-details-single mb-1 text-muted"
            v-if="taxonomies.themes"
        >
            <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-0">
                <DownFlagSvg />
            </span>
            {{ taxonomies.themes }}
        </div>
    </div>
</template>

<script>
import DownFlagSvg from "@/svg/DownFlagSvg.vue";

export default {
    components: { DownFlagSvg },

    props: ["taxonomies"],
};
</script>
